import styled from 'styled-components';
import {
    Button
  } from '@mds/mds-reactjs-library';

export const ButtonStyled = styled(Button)`
        margin-right: 12px;
        margin-bottom: 12px;
        span {
            display: flex;
        }
    `; 

export const Container = styled.div`
  position: relative;
  width: 100%;
  min-height : calc(100vh - 187px);
  background-color: white;
  border-bottom: 1px solid #ddd;
  overflow-y: auto;

    .loadingWrapper{
    width : 100%;
    min-height : 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        animation : spin 1s linear infinite;
    }
    @keyframes spin{
        to{
            transform : rotate(360deg)
        }
    }
  }

  .mds-alert{
    top : 90px;
    background: #051C2C;
    position : fixed;
    left : 0;
    width : 100vw;
    box-sizing: border-box;
    padding-right : 32px;
    z-index: 9999;
    a{
      color : #fff !important;
      text-decoration: underline !important;
    }
  }

  .reportPopupWrapper{
    width : 100vw;
    height : 100vh;
    position : fixed;
    z-index : 11;
    background : rgba(0,0,0,0.4);
    top : 0;
    bottom : 0;
    left : 0;
    right : 0;
    display : flex;
    align-items: center;
    justify-content: center;
    .reportPopup{
      min-width: 320px;
      box-sizing: border-box;
      background-color: #fff;
      padding : 40px;
      h1{
        font-size: 24px;
        font-weight: 500;
      }
      p{
        font-size: 14px;
        color : rgb(51,51,51);
        margin-top : 10px;
      }
      input[type=text]{
        color: #333;
        background-color: #fff;
        border: 1px solid #ccc;
        width: 100%;
        height: 38px;
        margin : 50px 0;
        padding: 8px 12px;
        font-size: 14px;
        line-height: 1.42857;
        box-sizing: border-box;
        display: block;
      }
      .buttons{
        display: flex;
        gap : 10px;
        justify-content: center;
      }
    }
  }
 .helpSection{
  width: 100%;
  padding-bottom: 10px;
 }
`;

export const HelpSection = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
    padding: 15px;
    border-radius: 100px;
    margin: 0 auto;
    max-width: 50%;
    font-size: 16px;
    color: #333;

    span {
        margin-right: 10px;
    }

    a {
        color: #2251FF;
        text-decoration: none;
    }

    a:hover {
        text-decoration: underline;
    }
`;

export const FilterContainer = styled.div`
  display: flex;
  align-items: flex-start;
`;

export const Sidebar = styled.div`
  width: 90%;
  padding: 20px;
  display: flex;
  flex-direction: column;
  font-family : Mckinseysans, sans-serif;
  gap: 1px;
  .header h3 {
    font-size: 24px;
}
  p.instruction {
    margin-bottom: 15px;
    margin-top: 8px;
    color : rgb(101, 101, 101);
    font-size: 16px;
  }

  p a {
    color: #2251ff;
  }

  .highcharts-button-symbol{
    display: none;
  }

  h3{
    font-size: 16px;
    line-height : 24px;
    font-weight : 400;
  }

  .highchart{
    width : 100%;
    min-height : 400px;
      >div{
        overflow : visible !important;
      }
      overflow : auto !important;
    
  }
  .custom-overflow {
  overflow: visible !important;
  }

  .loadingWrapper{
    width : 100%;
    min-height : 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    svg{
        animation : spin 1s linear infinite;
    }
    @keyframes spin{
        to{
            transform : rotate(360deg)
        }
    }
  }

  .SectionContainer {
    align-items : stretch;
    width: 100%;
    display : flex;
    }

  .filterButtonContainer{
    display : flex;
    gap : clamp(2px, 0.4vw, 8px);
    /* Single row: cards shrink to fit, scroll only when absolutely unavoidable. */
    flex-wrap: nowrap;
    overflow-x: auto;
    overflow-y: hidden;
    scrollbar-width: none; /* hide scrollbar Firefox */
    &::-webkit-scrollbar { display: none; } /* hide scrollbar Chrome/Safari */
    -webkit-overflow-scrolling: touch;
    justify-content: start;
    align-items : stretch;
    width: 100%;

    /* Allow each filter card to shrink but not grow; truncate text with ellipsis. */
    & > * {
      flex: 0 1 auto;
      min-width: 0;
      white-space: nowrap;
    }

    .download-button svg{
      width : 12px;
      height : 12px;
    }
  }
  .extractDownloadContainer {
    display : flex;
    align-items : right;
    gap : 8px;
    width: 30%;
    padding-right: 10px;

    .buttonContainer{
    display : flex;
    align-items : baseline;
    width: 100%;
     }
    }

  .button {
    min-width: 100% !important;
    }

`;

export const FilterButton = styled.button`
  padding: 10px;
  border: 1px solid #ddd;
  background-color: #fff;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: auto;
  &:hover {
    background-color: #f0f0f0;
  }
`;

export const CountBadge = styled.span`
  background-color: #007bff;
  color: #fff;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  margin-right: 8px;
`;

export const ModalOverlay = styled.div`
  position: fixed;
    top: 90px;
    height: calc(100vh - 90px);
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    right: 0;
    width: 400px;
    background: rgba(255, 255, 255, 1);
    box-shadow: -2px 0 2px rgba(0, 0, 0, 0.3);
    z-index: 10;
    box-sizing: border-box;
`;

export const ModalContent = styled.div`
  padding: 20px;
  flex: 1;
  display : flex;
  height : 75%;
  flex-direction : column;
`;

export const ModalHeader = styled.div`
  margin-bottom: 20px;
  position: relative;
`;

export const ModalTitle = styled.h2`
  font-size: 22px;
  margin-bottom: 10px;
  font-weight: 700;
`;

export const ModalStickyHeader = styled.div`
  background-color: white;
  z-index: 1;
  padding-bottom: 10px;
  border-bottom: 1px solid #ddd;
`;

export const CustomCheckbox = styled.input.attrs({ type: 'checkbox' })`
  border: 1px solid var(--colors--neutral-30);
  background-color: var(--colors--white);
  flex: none;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  margin-top: 2px;
  margin-bottom: 2px;
  display: flex;
  cursor: pointer;
`;

export const ModalDescription = styled.p`
  font-size: 14px;
  color: #666;
`;

export const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  position: absolute;
  top: 0;
  right: 0;
  padding: 5px;
  color: #333;
`;

export const FilterDefinitionsContainer = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 20px;
`;

export const ToggleSwitch = styled.div`
  position: relative;
  width: 40px;
  height: 20px;
  background-color: ${({ isActive }) => (isActive ? '#007bff' : '#ddd')};
  border-radius: 20px;
  cursor: pointer;
  margin-right: 10px;
  transition: background-color 0.2s;
`;

export const ToggleThumb = styled.div`
  position: absolute;
  top: 2px;
  left: ${({ isActive }) => (isActive ? '20px' : '2px')};
  width: 16px;
  height: 16px;
  background-color: #fff;
  border-radius: 50%;
  transition: left 0.2s;
`;

export const FilterDefinitionsLabel = styled.span`
  font-size: 14px;
  color: #333;
`;

export const CheckboxContainer = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: center;
`;

export const ChildCheckboxContainer = styled(CheckboxContainer)`
  margin-left: 20px;
`;

export const CheckboxLabel = styled.label`
  margin-left: 8px;
  font-size: 16px;
`;

export const FilterTitle = styled.h3`
 margin-top: 20px;
  margin-bottom: 20px;
  font-size: 18px;
  font-weight: 600;
`;

export const FilterActions = styled.div`
  padding: 10px 20px;
  display: flex;
  justify-content: flex-end;
  border-top: 1px solid #ddd;
  background-color: #fff;
  
  button {
    margin-left: 10px;
  }
`;

export const CancelButton = styled.button`
  padding: 8px 12px;
  background-color: #fff;
  color: #333;
  border: 1px solid #ddd;
  cursor: pointer;
`;

export const ApplyButton = styled.button`
  padding: 8px 12px;
  background-color: #007bff;
  color: #fff;
  border: none;
  cursor: pointer;
`;

export const ClearLabel = styled.label`
  float: 'right';
  color: grey;
  cursor: pointer;
  font-size: 12px;
  &:hover {
    font-size: 14px;
  }
`;